module.exports = __webpack_public_path__ + "img/guquan.c8b92bf0.png";